<!-- 

COMPONENTE PARA ANEXAR DOCUMENTOS


    <anexos-form v-if="showAnexosForm" :params="{ ref: 'item', chaveref: coditem, title: descricao, showForm: false }" @closeform="closeForm"></anexos-form>


params: { 
  ref: '',
  chaveref: '',
  title: '',
  showForm: false,
  }



 -->

<script>
import axios from 'axios'
import { apiORDS, apiORDSpost, apiORDSmidia, urlORDS } from '../shared/api-functions'

export default {
    props: {
      params: Object 
    },

    data () {
      return {
        listImages: [],
        selectedIndex: 0,
        chaveref: '',
        ref: '',
      }
    },

    computed: {
      title: function () {
        if (this.params.ref == 'item') {
          return 'Imagens de ' + this.params.title
        } else {
          return 'Anexos'
        }
      },

      fotosProduto: function () {
        return this.params.ref == 'item'
      },

      fileTypes: function () {
        if (this.fotosProduto)
          return 'image/*'
        else
          return ''
      },
    },

    methods: {
      handleClickRemove () {
        this.$emit('removeform')
      },

      closeForm(action) {
        this.$emit('closeform')
      },

      handleClickGaleria (index) {
          
        //this.mainImage = this.listImages[index].url
        this.selectedIndex = index
        this.$emit('saveform', { coddoc: this.listImages[index].coddoc, img: this.listImages[index].url})
      },

      async loadData() {
        //CARREGA IMAGENS
        await this.$store.dispatch('loadDocs', { id: this.ref + '/' + this.chaveref } )
        this.listImages = [...this.$store.getters.getDocsList]

        //EFETUA O DOWNLOAD DE CADA IMAGEM NA BARRA DE MINIATURAS
        if (this.params.showform) {
          for (var x = 0; x < this.listImages.length; x++) {
              this.$set(this.listImages[x], 'image', null)
              // this.loadMiniatura(x)
          }
        }
      },

      async loadMiniatura(index) {
        let self = this
        let test = index
        await apiORDSmidia(this.listImages[index].url).then(
            (data) => {
                if (data && data.size > 0) {
                    let reader = new window.FileReader()
                    reader.readAsDataURL(data)
                    reader.onload = function() {
                        self.listImages[test].image = reader.result
                        if (test == 0) {
                          //self.mainImage = reader.result
                        }
                    }
                }
            }
        )
      },



    },

    created () {
      this.chaveref = this.params.chaveref
      this.ref = this.params.ref
      this.loadData()
    }
  
}
</script>

<template>
 
  <div class="w-100">

    <!-- FORMULARIO DE IMAGENS -->
    <div v-if="params.showform" class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container nb-email-container" style="height: 90%; overflow: auto">
            <div class="nb-modal-header">
                <h4 class="def-title">{{ title }}</h4>
                <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="nb-modal-scrollable-body" style="height: 70%">
              <div class="row col" style="padding-left: 20px height: 80%">
                <div class="imagem-list text-center nb-margin-bottom" :class="{'active': selectedIndex == index}" v-for="(img, index) in listImages" :key="index">
                    <div v-if="!img.coddoc || !img.url" class="imagem-galeria-loading">
                      <div class="spinner-border text-muted"></div>
                    </div>
                    <img v-if="img.coddoc && img.url" class="imagem-galeria" :src="img.url" @click="handleClickGaleria(index)"><br>
                </div>
              </div>
            </div>
            <div class="nb-modal-footer" style="height: 10%">
                <button type="button" class="close" @click="handleClickRemove()" data-dismiss="modal" aria-label="Close">
                    <small><i class="fa fa-trash" aria-hidden="true"></i> Remover Imagem </small>
                </button>
            </div>
        </div>
    </div>
  </div>

</template>

<style>

.imagem-galeria {
    max-height: 80px;
    /* margin-right: 5px; */
}

.imagem-galeria-loading {
    height: 100%;
    width: 80px; 
    padding-top: 30px
}

.imagem-list {
    padding: 4px;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0,0,0,0.2);
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    -moz-box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    margin-right: 5px
}

.imagem-list.active {
    background-color: #67a0be!important;
}

.imagem-excluir {
    cursor: pointer; 
    background: white; 
    border: 1px solid #ccc;
    padding: 4px;    
}

.no-image {
    font-size: 72px; 
    color: silver; 
    cursor: pointer  
}

.adicionar-imagem {
    min-height: 100px;
    width: 152px;
    padding: 38px 5px 5px;
    float: left;
    font-size: 18px;
    text-align: center;
    border: 1px dashed #bbb;
    color: #888;
    background-color: #fff;
    cursor: pointer;
}

.attach-icon {
    /* font-size: 24px; */
    color: #808080bb;  
}

</style>





// WEBPACK FOOTER //
// src/components/anexos-selecionar-form.vue